import Component from '../Component';
export default class TextComponent extends Component {
    reactivityOptions = {
        keepRatio: false
    };
}
